/* eslint-disable react-hooks/exhaustive-deps */
import { Autocomplete, ToggleButtonGroup, ToggleButton } from "@material-ui/lab";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box, Tab, Tabs, Card, Grid, Divider, TextField } from "@material-ui/core";
import { PersonOutline, DashboardOutlined } from "@material-ui/icons";

import select from "../../utils/select";
import { getAllDepartments } from "../../reducer/department/action";

import ListPatent from "../../containers/Home/ListPatent";
import CTKHStatistic from "../../containers/Home/CTKHStatistic";
import ListMonograph from "../../containers/Home/ListMonograph";
import ListExhibition from "../../containers/Home/ListExhibition";
import ListProject from "../../containers/Home/ListProject/ListProject";
import ListSolution from "../../containers/Home/ListSolution/ListSolution";
import ScientifiResearchStatistic from "../../containers/Home/ScientificResearchStatistic";
import ListScientificResearch from "../../containers/Home/ListScientificResearch/ListScientificResearch";
import ScientifiResearchCoreCollectionStatistic from "../../containers/Home/ScientifiResearchCoreCollectionStatistic";
import ScientificResearchTypeStatistic from "../../containers/Home/ScientificResearchTypeStatistic";
import Stats from "../../containers/User/Stats/Stats";

function Home() {
  const dispatch = useDispatch();

  const [tab, setTab] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [viewMode, setViewMode] = useState("personal");
  const [chosenDepartmentId, setChosenDepartmentId] = useState([]);
  const [haveDepartmentsList, setHaveDepartmentsList] = useState(false);

  const url = window.location.href;
  const isGuestRoute = url.split("/").slice(-1)[0].toLowerCase().includes("guest");
  const isCNTTGuestRoute = isGuestRoute && url.split("/").slice(-1)[0].toLowerCase().includes("cntt");
  const isORlabGuestRoute = isGuestRoute && url.split("/").slice(-1)[0].toLowerCase().includes("orlab");

  // const departmentList = useSelector(state => select(state, 'departmentReducer', 'departments'));
  // filter bỏ "Toàn trường" khỏi danh sách khoa
  const departmentList = useSelector((state) =>
    select(state, "departmentReducer", "departments").filter((dept) => dept.id !== 0)
  );

  // Vừa vào lấy Department luôn
  useEffect(() => dispatch(getAllDepartments()), []);

  // Magic
  useEffect(() => {
    if (departmentList.length > 0) {
      setHaveDepartmentsList(true);

      // department_id của ORlab là 5
      if (isORlabGuestRoute) {
        setChosenDepartmentId([5]);
      }
      // department_id của khoa CNTT là 6
      else if (isCNTTGuestRoute) {
        setChosenDepartmentId([6]);
      }
    }
  }, [departmentList]);

  const handleViewModeChange = (event, newMode) => {
    if (newMode !== null) {
      setViewMode(newMode);
    }
  };

  // Nếu chọn chế độ "personal", hiển thị component Stats (thống kê cá nhân)
  if (viewMode === "personal") {
    return (
      <>
        <Box mb={2} display="flex" justifyContent="center">
          <ToggleButtonGroup value={viewMode} exclusive onChange={handleViewModeChange} aria-label="view mode">
            <ToggleButton value="personal" aria-label="personal stats">
              <PersonOutline style={{ marginRight: 8 }} />
              Cá nhân
            </ToggleButton>
            <ToggleButton value="school" aria-label="school dashboard">
              <DashboardOutlined style={{ marginRight: 8 }} />
              Toàn trường
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
        <Stats />
      </>
    );
  }

  const renderTab = () => {
    if (tab === 0)
      return (
        <ListScientificResearch
          chosenStartDate={startDate}
          chosenEndDate={endDate}
          chosenDepartmentId={chosenDepartmentId}
          haveDepartmentsList={haveDepartmentsList}
        />
      );

    var renderElm = null;
    switch (tab) {
      case 1:
        renderElm = (
          <ListSolution chosenStartDate={startDate} chosenEndDate={endDate} chosenDepartmentId={chosenDepartmentId} />
        );
        break;
      case 2:
        renderElm = (
          <ListPatent chosenStartDate={startDate} chosenEndDate={endDate} chosenDepartmentId={chosenDepartmentId} />
        );
        break;
      case 3:
        renderElm = (
          <ListMonograph chosenStartDate={startDate} chosenEndDate={endDate} chosenDepartmentId={chosenDepartmentId} />
        );
        break;
      case 4:
        renderElm = (
          <ListExhibition
            chosenStartDate={startDate}
            chosenEndDate={endDate}
            chosenDepartmentId={chosenDepartmentId}
          />
        );
        break;
      case 5:
        renderElm = (
          <ListProject chosenStartDate={startDate} chosenEndDate={endDate} chosenDepartmentId={chosenDepartmentId} />
        );
        break;
      default:
        return <>Rỗng</>;
    }

    return (
      <Grid item xs={12}>
        {renderElm}
      </Grid>
    );
  };

  return (
    <>
      <Box mb={2} display="flex" justifyContent="center">
        <ToggleButtonGroup value={viewMode} exclusive onChange={handleViewModeChange} aria-label="view mode">
          <ToggleButton value="personal" aria-label="personal stats">
            <PersonOutline style={{ marginRight: 8 }} />
            Cá nhân
          </ToggleButton>
          <ToggleButton value="school" aria-label="school dashboard">
            <DashboardOutlined style={{ marginRight: 8 }} />
            Toàn trường
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
      <Grid container spacing={1} style={{ height: "100%" }}>
        <Grid item xs={12} lg={7}>
          <Card style={{ minHeight: "calc(100vh - 92px)", maxHeight: "calc(100vh - 92px)" }}>
            <Grid container justifyContent="center">
              <Grid item xs={7} sm={8}>
                <Tabs
                  value={tab}
                  scrollButtons="off"
                  variant="scrollable"
                  textColor="secondary"
                  onChange={(_, value) => setTab(value)}
                >
                  <Tab label="Công bố khoa học" />
                  <Tab label="Giải pháp hữu ích" />
                  <Tab label="Bằng sáng chế" />
                  <Tab label="Sách" />
                  <Tab label="Triển lãm" />
                  <Tab label="Đề tài" />
                </Tabs>
              </Grid>
              <Grid item xs={5} sm={4}>
                <Box display="flex" style={{ marginTop: 7, marginRight: 16 }}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    type="date"
                    label="Từ ngày"
                    value={startDate}
                    onChange={(event) => setStartDate(event.target.value)}
                    InputLabelProps={{ shrink: true }}
                    style={{ backgroundColor: "#fff", marginRight: 8 }}
                  />
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    type="date"
                    label="Đến ngày"
                    value={endDate}
                    onChange={(event) => setEndDate(event.target.value)}
                    InputLabelProps={{ shrink: true }}
                    style={{ backgroundColor: "#fff" }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
            </Grid>
            <Grid container spacing={2} justifyContent="center" style={{ padding: 16 }}>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  multiple
                  options={departmentList || []}
                  getOptionLabel={(option) => option.name}
                  filterSelectedOptions
                  disabled={isORlabGuestRoute || isCNTTGuestRoute}
                  onChange={(_, val) => setChosenDepartmentId(val?.map((v) => v.id) || [])}
                  value={departmentList?.filter((e) => chosenDepartmentId.includes(e.id)) || []}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      label="Đơn vị"
                      variant="outlined"
                      placeholder={chosenDepartmentId.length === 0 ? "Toàn trường" : "Chọn đơn vị"}
                    />
                  )}
                />
              </Grid>
              {tab !== 0 && (
                <Grid item xs={12}>
                  <Divider
                    style={{
                      marginLeft: -16,
                      backgroundColor: "#fff",
                      width: "calc(100% + 32px)",
                      boxShadow: "rgb(0 0 0 / 16%) 0px 2px 3px",
                    }}
                  />
                </Grid>
              )}
              {renderTab()}
            </Grid>
          </Card>
        </Grid>
        <Grid item xs={12} lg={5} style={{ minHeight: "calc(100vh - 100px)", maxHeight: "calc(100vh - 100px)" }}>
          <Box height="25%">
            <ScientifiResearchCoreCollectionStatistic
              chosenStartDate={startDate}
              chosenEndDate={endDate}
              chosenDepartmentId={chosenDepartmentId}
            />
          </Box>
          <Box height="25%" style={{ marginTop: 8 }}>
            <ScientificResearchTypeStatistic
              chosenStartDate={startDate}
              chosenEndDate={endDate}
              chosenDepartmentId={chosenDepartmentId}
            />
          </Box>
          <Card style={{ marginTop: 8, padding: "0 32px", width: "calc(100% - 64px)", height: "25%" }}>
            <ScientifiResearchStatistic
              chosenStartDate={startDate}
              chosenEndDate={endDate}
              chosenDepartmentId={chosenDepartmentId}
            />
          </Card>
          <Card style={{ marginTop: 8, padding: "0 32px", width: "calc(100% - 64px)", height: "25%" }}>
            <CTKHStatistic chosenStartDate={startDate} chosenEndDate={endDate} chosenDepartmentId={chosenDepartmentId} />
          </Card>
        </Grid>
      </Grid>
    </>
  );
}

export default Home;

